(function(){
  'use strict';

  if (window.__ES_STATIC_PAGES_RUNTIME_BOOT__) return;
  window.__ES_STATIC_PAGES_RUNTIME_BOOT__ = true;

  var state = {
    pageshowBound: false,
    sectionLoadBound: false,
    aboutFeedRoots: new WeakMap()
  };

  function jqReady(cb){
    if (typeof window.ES_jqReady === 'function') {
      window.ES_jqReady(function($){ cb($ || window.jQuery); });
      return;
    }
    if (window.jQuery) {
      cb(window.jQuery);
      return;
    }
    document.addEventListener('DOMContentLoaded', function(){ cb(window.jQuery); }, { once: true });
  }

  function parseIntSafe(v, fallback){
    var n = parseInt(v, 10);
    return isFinite(n) ? n : fallback;
  }

  function parseBool(v){
    if (typeof v !== 'string') return !!v;
    return v === 'true' || v === '1' || v === 'yes';
  }

  function initAboutInstagram($){
    if (!$ || !$.fn || !$.fn.slick) return;

    document.querySelectorAll('.about-instagram[data-es-about-instagram]').forEach(function(root){
      var slider = root.querySelector('.js-instagram');
      if (!slider) return;
      var $slider = $(slider);
      if ($slider.hasClass('slick-initialized')) return;

      var isFeedMode = parseBool(root.getAttribute('data-es-instagram-feed-mode'));
      var userId = root.getAttribute('data-es-instagram-user-id') || '';
      var accessToken = root.getAttribute('data-es-instagram-access-token') || '';
      var limit = parseIntSafe(root.getAttribute('data-es-instagram-limit'), 8);
      var iconClass = root.getAttribute('data-es-instagram-icon') || 'fa fa-instagram';
      var targetId = root.getAttribute('data-es-instagram-target') || slider.id || 'engoj_section_instagram_v2';
      var rtlEnabled = parseBool(root.getAttribute('data-es-instagram-rtl'));
      var prevArrow = isFeedMode
        ? '<button type="button" class="slick-prev "><i class="fa fa-angle-left"></i></button>'
        : '<button type="button" class="button-prev "><i class="fa fa-angle-left"></i></button>';
      var nextArrow = isFeedMode
        ? '<button type="button" class="slick-next "><i class="fa fa-angle-right"></i></button>'
        : '<button type="button" class="button-next "><i class="fa fa-angle-right"></i></button>';

      function slickInit(){
        if ($slider.hasClass('slick-initialized')) return;
        $slider.slick({
          arrows: !isFeedMode,
          dots: false,
          infinite: false,
          autoplay: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          rtl: rtlEnabled,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          responsive: [
            {
              breakpoint: isFeedMode ? 1400 : 1600,
              settings: { slidesToShow: 4, slidesToScroll: 1 }
            },
            {
              breakpoint: 1199,
              settings: { slidesToShow: 4, slidesToScroll: 1 }
            },
            {
              breakpoint: 1024,
              settings: { slidesToShow: 3, slidesToScroll: 1 }
            },
            {
              breakpoint: 600,
              settings: { slidesToShow: 2, slidesToScroll: 1 }
            }
          ]
        });
      }

      if (!isFeedMode) {
        slickInit();
        return;
      }

      if (!window.Instafeed || !userId || !accessToken) {
        slickInit();
        return;
      }

      var target = document.getElementById(targetId);
      if (!target) {
        slickInit();
        return;
      }
      if (target.children && target.children.length) {
        slickInit();
        return;
      }
      if (state.aboutFeedRoots.get(root)) return;

      var feed = new window.Instafeed({
        get: 'user',
        userId: userId,
        accessToken: accessToken,
        template: '<div class="content relative hover-images "><img src="{{image}}" class="img-responsive"><div class="absolute content_text flex center"><a href="{{link}}" class="delay03 inline-block" target="_blank" rel="noopener"><i class="'+ iconClass +'"></i></a></div></div>',
        target: targetId,
        resolution: 'standard_resolution',
        limit: String(limit),
        after: slickInit
      });

      state.aboutFeedRoots.set(root, true);
      try {
        feed.run();
      } catch (_err) {
        slickInit();
      }
    });
  }

  function initAboutTeams($){
    if (!$ || !$.fn || !$.fn.slick) return;
    document.querySelectorAll('.slick_teams[data-es-slick-teams]').forEach(function(node){
      var $node = $(node);
      if ($node.hasClass('slick-initialized')) return;
      $node.slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: false,
            arrows: false
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false
          }
        }]
      });
    });
  }

  function initCustomerAddresses(){
    if (!window.Shopify) return;
    if (typeof window.Shopify.CountryProvinceSelector !== 'function') return;

    var newCountry = document.getElementById('AddressCountryNew');
    var newProvince = document.getElementById('AddressProvinceNew');
    if (newCountry && newProvince && !newCountry.dataset.esCountryProvinceInit) {
      newCountry.dataset.esCountryProvinceInit = '1';
      new window.Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    document.querySelectorAll('select[id^="AddressCountry_"]').forEach(function(countrySelect){
      if (countrySelect.dataset.esCountryProvinceInit) return;
      var suffix = countrySelect.id.replace('AddressCountry_', '');
      var provinceId = 'AddressProvince_' + suffix;
      var hideId = 'AddressProvinceContainer_' + suffix;
      if (!document.getElementById(provinceId)) return;
      countrySelect.dataset.esCountryProvinceInit = '1';
      new window.Shopify.CountryProvinceSelector(countrySelect.id, provinceId, {
        hideElement: hideId
      });
    });

    window.Shopify.CustomerAddress = {
      toggleForm: function(id) {
        var editEl = document.getElementById('EditAddress_' + id);
        if (!editEl) return false;
        editEl.style.display = editEl.style.display === 'none' ? '' : 'none';
        return false;
      },
      toggleNewForm: function() {
        var el = document.getElementById('AddAddress');
        if (!el) return false;
        el.style.display = el.style.display === 'none' ? '' : 'none';
        return false;
      },
      destroy: function(id, confirmMsg) {
        if (confirm(confirmMsg || 'Are you sure you wish to delete this address?')) {
          window.Shopify.postLink('/account/addresses/' + id, { parameters: { _method: 'delete' } });
        }
      }
    };
  }

  function initAll(){
    jqReady(function($){
      initAboutInstagram($);
      initAboutTeams($);
      initCustomerAddresses();
    });
  }

  if (!state.pageshowBound) {
    state.pageshowBound = true;
    window.addEventListener('pageshow', initAll);
  }
  if (!state.sectionLoadBound) {
    state.sectionLoadBound = true;
    document.addEventListener('shopify:section:load', initAll);
  }

  initAll();
})();
